import { useRef } from "react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { geoAction } from "../../redux/actions/geolocationActions";
const RegionModal = ({ countryList, setCountry, setModal }) => {
  let closeModal = useRef();
  let dispatch = useDispatch();
  const handleRegionChange = (e, child) => {
    Cookies.set("geolocation", child, { expires: 1 });
    dispatch(geoAction());
    setCountry(child.country_name);
    closeModal.current.click();
    const overlay = document.querySelector(".modal-backdrop");
    if (overlay) overlay.remove();
    document.documentElement.scrollTop = 0;
    setModal(false);
  };
  return (
    <div
      className="modal fade"
      id="myModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="gridSystemModalLabel"
      style={{
        marginLeft: window.innerWidth > 992 ? "-15px" : "0",
      }}
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setModal(false)}
            >
              <span aria-hidden="true" ref={closeModal}>
                &times;
              </span>
            </button>
            <h4 className="modal-title" id="gridSystemModalLabel">
              Change Region
            </h4>
          </div>
          <div className="modal-body">
            <div className="row">
              {countryList.item?.country
                ? countryList.item?.country?.map((parent, i) => (
                    <div
                      key={i}
                      className="col-xs-12 col-sm-6 col-md-3 col-lg-3"
                      style={{ border: "solid red 0px" }}
                    >
                      <div className="modal_region_name">
                        {parent.group_name}
                      </div>
                      <div className="row">
                        {parent.items.map((child, j) => (
                          <div
                            key={j}
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12 modal_country_name"
                            style={{ border: "solid red 0px" }}
                          >
                            <span
                              rel={child.country_id}
                              className="4 child-country"
                              onClick={(e) => handleRegionChange(e, child)}
                            >
                              {child.country_name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                : countryList.error?.message}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
              onClick={() => setModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegionModal;
